import { render } from "./ExternalLinkIcon.vue?vue&type=template&id=5113fd61"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__